// Select the necessary elements
const megaMenu = document.querySelector('.mega-menu');
const megaMenuContainer = document.querySelector('.mega-menu__container');
const header = document.querySelector('.header');
const megaMenuTrigger = document.querySelector('[trigger="hover"]');

// Set the initial state when the page loads (before hover)
function setInitialState() {
  megaMenu.style.opacity = '0';
  megaMenu.style.transform = 'translateY(10px)';
  megaMenu.style.pointerEvents = 'none';

  megaMenuContainer.style.visibility = 'hidden';
  megaMenuContainer.style.transform = 'translateY(-100%)';

  // Ensure header background is transparent initially
  header.style.backgroundColor = 'transparent';
}

// Set hover state when the menu is triggered
function setHoverState() {
  megaMenu.style.opacity = '1';
  megaMenu.style.transform = 'translateY(0)';
  megaMenu.style.pointerEvents = 'auto';

  megaMenuContainer.style.visibility = 'visible';
  megaMenuContainer.style.transform = 'translateY(0)';

  // Change header background to black when hovering
  header.style.backgroundColor = 'rgba(37, 37, 37, 1)';
}

// Remove hover state when exiting
function removeHoverState() {
  megaMenu.style.opacity = '0';
  megaMenu.style.transform = 'translateY(10px)';
  megaMenu.style.pointerEvents = 'none';

  megaMenuContainer.style.visibility = 'hidden';
  megaMenuContainer.style.transform = 'translateY(-100%)';

  // Revert header background to transparent on hover exit
  header.style.backgroundColor = 'transparent';
}

// Add event listeners for hover state control
if (megaMenuTrigger) {
  megaMenuTrigger.addEventListener('mouseenter', setHoverState);
  megaMenuTrigger.addEventListener('mouseleave', removeHoverState);
}

// Set the initial state when the page loads
setInitialState();
